module.exports = __webpack_public_path__ + "static/media/Enter Campaign Details.a3590c83.png";